(() => {
  const root = document.documentElement;

  const updateHeaderHeight = () => {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');

    if (!headerGroup) return;

    root.style.setProperty('--nftp-header-group-height', `${headerGroup.offsetHeight}px`);
  };

  document.addEventListener('DOMContentLoaded', () => {
    root.classList.add('nftp-theme-ready');
    updateHeaderHeight();
  });

  window.addEventListener('resize', updateHeaderHeight, { passive: true });

  document.addEventListener('shopify:section:load', updateHeaderHeight);
  document.addEventListener('shopify:section:unload', updateHeaderHeight);
})();
